var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",class:{invisible: !_vm.showSpinner}},[_c('b-spinner',{staticClass:"mr-3",attrs:{"type":"grow"}}),_vm._v("\n    "+_vm._s(_vm.text || 'Loading...')+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }